export { default } from '../sewpat/SingleSewpatView';



// WEBPACK FOOTER //
// ./src/components/async/SingleSewpatView.js